// extracted by mini-css-extract-plugin
export default {"primary-footer":"footer_primary-footer__1dQee","footer-items":"footer_footer-items__YCY2D","footerItems":"footer_footerItems__rWa0a"};